import React from 'react';

const TermsAndConditionsContainer = () => {
	return <div>Regulamin</div>;
};

export default TermsAndConditionsContainer;
